import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading } from "../../repository/slice";
import { getSingleQuiz } from "../getSingleQuiz/action";

function* addQuizQuestionImageWorker({ payload }: any): SagaIterator {
    try {
        const formData = new FormData();
        for (const [key, value] of Object.entries(payload.body as Object)) {
            const isValue = value !== null && value !== undefined && value !== "";
            if (isValue) {
                formData.append(key, value);
            }
        };
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.post, `/api/questionnaire-questions/${payload.body.questionId}/add-image`, formData);
        if (isError) {
            
        } else {
            if(payload?.quizId){
                yield put(getSingleQuiz({id: Number(payload.quizId)}));
            }
        }
    } catch (error) {
        console.error("addQuizQuestionImageWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* addQuizQuestionImageWatcher() {
    yield takeLatest("@saga/QUESTION_QUIZ_ADD_IMAGE", addQuizQuestionImageWorker);
};
